// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2BWvc","col":"styles_col__2TglV"};